/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Streamerreport_Heading1Inputs */

const ja_playdata_streamerreport_heading1 = /** @type {(inputs: Playdata_Streamerreport_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストリーマーレポート`)
};

const en_playdata_streamerreport_heading1 = /** @type {(inputs: Playdata_Streamerreport_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streamer Report`)
};

/**
* | output |
* | --- |
* | "Streamer Report" |
*
* @param {Playdata_Streamerreport_Heading1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_streamerreport_heading1 = /** @type {((inputs?: Playdata_Streamerreport_Heading1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Streamerreport_Heading1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_streamerreport_heading1(inputs)
	return en_playdata_streamerreport_heading1(inputs)
});
export { playdata_streamerreport_heading1 as "playdata_streamerReport_heading" }